import React from 'react';
import { ToolbarProps } from 'react-big-calendar';
import { PrimeIcons } from 'primereact/api';
import { calendarMessages } from '../../utils/calendarUtils';
import { CalendarEvent, getToolbarLabel, reservationsCalendarMessages } from './calendarViews';

export type ReservationsCalendarToolbarProps = ToolbarProps<CalendarEvent, object> & {
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
  hiddenWeekdays?: readonly number[];
};

export function ReservationsCalendarToolbar(props: ReservationsCalendarToolbarProps) {
  const { date, view, views, onNavigate, onView, isFullscreen, onToggleFullscreen, hiddenWeekdays } = props;
  const toolbarLabel = getToolbarLabel(view, date, hiddenWeekdays);

  return (
    <div className='rbc-toolbar'>
      <span className='rbc-btn-group'>
        <button type='button' onClick={() => onNavigate('PREV')}>
          {calendarMessages.previous}
        </button>
        <button type='button' onClick={() => onNavigate('TODAY')}>
          {calendarMessages.today}
        </button>
        <button type='button' onClick={() => onNavigate('NEXT')}>
          {calendarMessages.next}
        </button>
      </span>

      <span className='rbc-toolbar-label'>{toolbarLabel}</span>

      <span className='rbc-btn-group'>
        {Object.values(views).map((availableView) => {
          const message = reservationsCalendarMessages[availableView as keyof typeof reservationsCalendarMessages];
          const viewLabel = typeof message === 'string' ? message : availableView;

          return (
            <button
              key={availableView}
              type='button'
              className={availableView === view ? 'rbc-active' : undefined}
              onClick={() => onView(availableView)}
            >
              {viewLabel}
            </button>
          );
        })}
        {onToggleFullscreen && (
          <button
            type='button'
            className='fullscreen-toggle-button'
            onClick={onToggleFullscreen}
            aria-label={isFullscreen ? 'Cerrar pantalla completa' : 'Ver en pantalla completa'}
            title={isFullscreen ? 'Cerrar pantalla completa' : 'Ver en pantalla completa'}
          >
            <i className={isFullscreen ? PrimeIcons.TIMES : PrimeIcons.WINDOW_MAXIMIZE} />
          </button>
        )}
      </span>
    </div>
  );
}
